"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareAndCopyDialog = void 0;
var _components = require("@ori-ui/components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _ShareButton = require("../ShareButton");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ShareAndCopyDialog = props => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    copy,
    linkCopied,
    modalTitle
  } = (0, _hooks.useTranslations)();
  const {
    copyUrl,
    color = 'default',
    size = 'large',
    variant = 'contained',
    openDialog = false
  } = props;
  const {
    onOpen,
    onClose,
    open
  } = (0, _presentationHooks.useDisclose)({
    defaultOpen: openDialog
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": getTestId(_constants.SHARE_AND_COPY_DIALOG_ID),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ShareButton.ShareButton, {
      size: size,
      variant: variant,
      color: color,
      onClick: onOpen
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DialogRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
        header: modalTitle,
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CopyLinkInputButton, {
          link: copyUrl,
          buttonText: copy,
          copiedText: linkCopied
        })
      })
    })]
  });
};
exports.ShareAndCopyDialog = ShareAndCopyDialog;
//# sourceMappingURL=ShareAndCopyDialog.js.map